module.exports = __webpack_public_path__ + "img/withdraw-wallet.4fb86e38.svg";